// extracted by mini-css-extract-plugin
export default {"header":"profile_header__2YEqP","mainContainer":"profile_mainContainer__c6hVR"};